// extracted by mini-css-extract-plugin
export default {"list":"CategoryList-list-1p1","title":"CategoryList-title-2la","desc":"CategoryList-desc-iPA"};